require('./brokerProductAdvancedSearch.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { connect } = require('react-redux');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const PaginationButtons = require('components/commons/paginationButtons/paginationButtons');
const LoadingWithOpacity = require('components/commons/loadingWithOpacity/loadingWithOpacity');
const { CommercialAdsCCValidated : CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');

// @ components
const BrokerAdvancedSearchResultList = require('components/broker/brokerAdvancedSearchResultList/brokerAdvancedSearchResultList');
const AdvancedSearchEmptyStateRetry = require('components/broker/brokerSearchWidgetEmptyStateRetry/brokerSearchWidgetEmptyStateRetry');
const BrokerWatchlistModal = require('components/broker/brokerWatchlistModal/brokerWatchlistModal');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const BrokerIABanner = require('components/broker/brokerIA/brokerIAComponents/brokerIABanner/brokerIABanner')

// @actions
const BrokerWatchlistActions = require('actions/brokerWatchlist');

// @constants
const {
    BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES,
    TYPE_ETFS,
    TYPE_FUNDS,
    TYPE_MIXED,
    TYPE_PLANS,
    TYPE_STOCKS,
    TYPE_WARRANTS,
    ALTERNATIVE_FUNDS,
} = require('constants/index');
const {
    PLANS_OPERATIONS_WARNING_MODAL,
    NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES,
} = require('constants/flagBasedFeatures');

// @ utilities
import { recordLinkV2 } from "utilities/tagging"

class BrokerProductAdvancedSearch extends React.Component {
    constructor(props) {
        super(props);

        this.addProductToWatchlist = this.addProductToWatchlist.bind(this);
        this.deleteProductFromList = this.deleteProductFromList.bind(this);
        this.onSubmitExistingList = this.onSubmitExistingList.bind(this);
        this.handleWatchlistModalToggle = this.handleWatchlistModalToggle.bind(this);
        this.onCancelForNewList = this.onCancelForNewList.bind(this);
        this.onSubmitNewList = this.onSubmitNewList.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures, resetWatchlistDetails, getUserWatchlist } = this.props;

        if(immFlagBasedFeatures.get('watchlist-enabled')) {
            resetWatchlistDetails();
            getUserWatchlist();
        }
    }

    addProductToWatchlist(isin, micCode, producttype, index) {
        const { productDetailsToList, addToExistingList, watchlistModalToggle, immBrokerWatchlist } = this.props;
        productDetailsToList(isin, micCode, producttype, index);
        const listSelectedIdForParam = immBrokerWatchlist.get('listSelectedIdForParam');
        if (listSelectedIdForParam > 0) {
            addToExistingList(listSelectedIdForParam);
        }
        watchlistModalToggle(true);
    }

    deleteProductFromList(id, isin, micCode, productName, status, deleteProduct, producttype, productKey) {
        this.props.deleteProductFromList(
            id,
            isin,
            micCode,
            productName,
            status,
            deleteProduct,
            producttype,
            productKey
        );
    }

    onSubmitExistingList() {
        const { immBrokerWatchlist, addToExistingList } = this.props;
        const selectedId = immBrokerWatchlist.get('listSelectedId');
        addToExistingList(selectedId);
    }

    handleWatchlistModalToggle(id) {
        this.props.listSelected(id);
    }

    onCancelForNewList() {
        this.props.createNewList();
        this.cancelWatchlistModal();
    }

    onSubmitNewList() {
        this.props.submitNewListName();
        this.props.getUserWatchlist();
    }

    buildWatchlistModal() {
        const { immBrokerWatchlist, createNewList, resetWatchlistDetails, saveListName } = this.props;
        const watchlistContent = immBrokerWatchlist.get('watchlistContent');
        const isModalOpen = immBrokerWatchlist.get('isModalOpen');
        const listName = immBrokerWatchlist.get('listName');
        const emptyWatchlist = immBrokerWatchlist.get('emptyWatchlist');
        const listSelectedId = immBrokerWatchlist.get('listSelectedId');

        if (watchlistContent.size > 0 && !emptyWatchlist) {
            return (
                <BrokerWatchlistModal
                    watchlistContent={watchlistContent}
                    isModalOpen={isModalOpen}
                    modifier={'addToList'}
                    handleNewListModal={createNewList}
                    handleCancelForModal={resetWatchlistDetails}
                    handleContinueForExistingList={this.onSubmitExistingList}
                    onChangeListSelected={this.handleWatchlistModalToggle}
                    listSelectedId={listSelectedId}
                />
            )
        } else {
            return (
                <BrokerWatchlistModal
                    watchlistContent={watchlistContent}
                    isModalOpen={isModalOpen}
                    modifier={'createNewList'}
                    saveListName={saveListName}
                    listName={listName}
                    handleCancelForModal={this.onCancelForNewList}
                    handleContinueForNewList={this.onSubmitNewList}
                />
            )
        }
    }

    getEmptyState() {
        const primaryText = (
            <div className="broker-product-advanced-search__empty-state--text">
                <div>
                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_noResultsText1" />
                </div>
                <div>
                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_noResultsText2" />
                </div>
            </div>
        );
        const searchTerm = this.props.immBrokerProductAdvancedSearch.get('savedFilters').text || '';
        recordLinkV2({
            eventCategory: 'broker/buscador-avanzado',
            eventAction:'noResults',
            eventLabel: searchTerm
        });

        return (
            <div className="row broker-product-advanced-search__empty-state">
                <EmptyState
                    secondaryText={primaryText}
                    iconType="noitems-wealth"
                    withMargin={false}
                />
            </div>
        );
    }

    buildPagenatedResultList() {
        const {
            immBrokerProductAdvancedSearch,
            immFlagBasedFeatures,
            hasNoStockContracts,
            handleClickSelectButton,
            searchWithPage,
            searchSpecificProduct,
            searchSpecificProductTracking,
            showSelectButton,
            stopViewMoreRedirections,
            watchlistTutorialHasBeenShown
        } = this.props;
        const onlyOneProductType = immBrokerProductAdvancedSearch.get('onlyOneProductType');
        const pageNumber = immBrokerProductAdvancedSearch.get('pageNumber');
        const totalPages = immBrokerProductAdvancedSearch.getIn(['results', onlyOneProductType, 'totalPages']);
        const watchlistEnabled = immFlagBasedFeatures.get('watchlist-enabled');

        return (
            <React.Fragment>
                <BrokerAdvancedSearchResultList
                    addProductToList={this.addProductToWatchlist}
                    deleteProductFromList={this.deleteProductFromList}
                    immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    hasNoStockContracts={hasNoStockContracts}
                    searchSpecificProduct={searchSpecificProduct}
                    searchSpecificProductTracking={searchSpecificProductTracking}
                    stopViewMoreRedirections={stopViewMoreRedirections}
                    showSelectButton={showSelectButton}
                    handleClickSelectButton={handleClickSelectButton}
                    watchlistEnabled={watchlistEnabled}
                    watchlistTutorialHasBeenShown={watchlistTutorialHasBeenShown}
                />
                <PaginationButtons
                    totalPages={totalPages}
                    callbackFunction={searchWithPage}
                    pageNumber={pageNumber}
                />
            </React.Fragment>
        );
    }

    buildResultList() {
        const {
            immBrokerProductAdvancedSearch,
            immFlagBasedFeatures,
            hasNoStockContracts,
            handleClickSelectButton,
            searchSpecificProduct,
            searchSpecificProductTracking,
            stopViewMoreRedirections,
            showSelectButton,
            watchlistTutorialHasBeenShown
        } = this.props;
        const watchlistEnabled = immFlagBasedFeatures.get('watchlist-enabled');

        return (
            <BrokerAdvancedSearchResultList
                addProductToList={this.addProductToWatchlist}
                deleteProductFromList={this.deleteProductFromList}
                immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                immFlagBasedFeatures={immFlagBasedFeatures}
                hasNoStockContracts={hasNoStockContracts}
                searchSpecificProduct={searchSpecificProduct}
                searchSpecificProductTracking={searchSpecificProductTracking}
                stopViewMoreRedirections={stopViewMoreRedirections}
                showSelectButton={showSelectButton}
                handleClickSelectButton={handleClickSelectButton}
                watchlistEnabled={watchlistEnabled}
                watchlistTutorialHasBeenShown={watchlistTutorialHasBeenShown}
            />
        );
    }

    getResultListContent() {
        const {
            immBrokerProductAdvancedSearch,
            retryAdvancedSearch,
            retryAdvancedSearchSpecificProduct
        } = this.props;
        const isOnlyOneProduct = immBrokerProductAdvancedSearch.get('isOnlyOneProduct');
        const retry = isOnlyOneProduct ? retryAdvancedSearchSpecificProduct : retryAdvancedSearch;
        const searchFailed = immBrokerProductAdvancedSearch.get('error');

        if (searchFailed) {
            return (
                <div className="row broker-product-advanced-search__empty-results-state">
                    {AdvancedSearchEmptyStateRetry(retry)}
                </div>
            );
        }
        else {
            if(isOnlyOneProduct) {
                return this.buildPagenatedResultList();
            }
            else {
                return this.buildResultList();
            }
        }
    }

    buildFiscalWarning() {
        const { immBrokerAttentionPlanStartingModal, immBrokerProductFiltersSearch } = this.props;
        const productTypes = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]);
        const activeProduct = productTypes.some(product => product['value'] === TYPE_PLANS.toUpperCase());
        const today = new Date();
        const initialDate = immBrokerAttentionPlanStartingModal.get('firstDate');
        const closeDate = immBrokerAttentionPlanStartingModal.get('endDate');

        if (activeProduct && initialDate <= today && today <= closeDate) {
            return (
                <FeatureTogglingRender notAllowedProductKey={PLANS_OPERATIONS_WARNING_MODAL}>
                    <div className="broker-product-advanced-search__disclaimer-personal-info">
                        <OKMessage type="informative" modifier="dark-bg">
                            <FormattedText value="brokerAttentionPlanStartingModal-fiscalDisclaimer" />
                        </OKMessage>
                    </div>
                </FeatureTogglingRender>
            );
        }
    }

    buildLegalTextByProduct(productType, hasLink, hasSecondParagraph, hasThirdParagraph) {
        const text1 = (
            <div className="broker-product-advanced-search__legal-text-paragraph1">
                <FormattedText
                    value={`brokerAdvancedSearch-brokerAdvancedSearch_${productType}LegalText1`}
                />
            </div>)

        const text2 = hasSecondParagraph ? (
            <div className="broker-product-advanced-search__legal-text-paragraph2">
                <FormattedText
                    value={`brokerAdvancedSearch-brokerAdvancedSearch_${productType}LegalText2`}
                />
            </div>
        ) : null;

        const text3 = hasThirdParagraph ? (
            <div className="broker-product-advanced-search__legal-text-paragraph3">
                <FormattedText
                    value={`brokerAdvancedSearch-brokerAdvancedSearch_${productType}LegalText3`}
                />
            </div>
        ) : null;

        return (
            <div className="broker-product-advanced-search__legal-text">
                {text1}
                {text2}
                {text3}
            </div>
        );
    }

    buildLegalText() {
        const {immBrokerProductAdvancedSearch} = this.props;
        const productTypeSelected = immBrokerProductAdvancedSearch.get('onlyOneProductType');
        let content, hasLink, hasSecondParagraph, hasThirdParagraph;
        switch (productTypeSelected) {
            case TYPE_ETFS:
                hasSecondParagraph = false;
                hasLink = false;
                hasThirdParagraph = false;
                content = this.buildLegalTextByProduct(TYPE_ETFS, hasLink, hasSecondParagraph, hasThirdParagraph);
                break;
            case TYPE_FUNDS:
                hasSecondParagraph = true;
                hasLink = true;
                hasThirdParagraph = false;
                content = this.buildLegalTextByProduct(TYPE_FUNDS, hasLink, hasSecondParagraph, hasThirdParagraph);
                break;
            case ALTERNATIVE_FUNDS:
                hasSecondParagraph = true;
                hasLink = true;
                hasThirdParagraph = false;
                content = this.buildLegalTextByProduct(ALTERNATIVE_FUNDS, hasLink, hasSecondParagraph, hasThirdParagraph);
                break;
            case TYPE_PLANS:
                hasSecondParagraph = true;
                hasLink = false;
                hasThirdParagraph = false;
                content = this.buildLegalTextByProduct(TYPE_PLANS, hasLink, hasSecondParagraph, hasThirdParagraph);
                break;
            case TYPE_STOCKS:
                hasSecondParagraph = false;
                hasLink = false;
                hasThirdParagraph = false;
                content = this.buildLegalTextByProduct(TYPE_STOCKS, hasLink, hasSecondParagraph, hasThirdParagraph);
                break;
            case TYPE_WARRANTS:
                hasSecondParagraph = false;
                hasLink = false;
                hasThirdParagraph = false;
                content = this.buildLegalTextByProduct(TYPE_WARRANTS, hasLink, hasSecondParagraph, hasThirdParagraph);
                break;
            default:
                hasSecondParagraph = true;
                hasLink = true;
                hasThirdParagraph = true;
                content = (
                    <div className="broker-product-advanced-search__legal-text-container">
                        {this.buildLegalTextByProduct(TYPE_MIXED, hasLink, hasSecondParagraph, hasThirdParagraph)}
                    </div>
                );
                break;
        }
        return content;
    }

    buildContent() {
        const {
            hideCommercialAds,
            immBrokerProductAdvancedSearch,
            immBrokerProductFiltersSearch,
            retryCombosFilters,
            updateFiltersCombosConfiguration,
            immFlagBasedFeatures,
            immProfile,
        } = this.props;
        const isFetching = immBrokerProductAdvancedSearch.get('isFetching');
        const isFetchingFilters = immBrokerProductFiltersSearch.get('isFetchingFilters');
        const errorfilters = immBrokerProductFiltersSearch.get('errorFilters');
        const filtersConfiguration = immBrokerProductFiltersSearch.get('filtersConfiguration');
        const onHandleRetryFiltersFailed = filtersConfiguration ? updateFiltersCombosConfiguration : retryCombosFilters;
        const searchEmpty = immBrokerProductAdvancedSearch.get('searchEmpty');
        const fetched = immBrokerProductAdvancedSearch.get('fetched');
        const isOnlyOneProduct = immBrokerProductAdvancedSearch.get('isOnlyOneProduct');
        const searchFailed = immBrokerProductAdvancedSearch.get('error');
        const brokerIAFlag = immFlagBasedFeatures.get(NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES);
        const brokerIAEnabled = !!brokerIAFlag && !brokerIAFlag.includes(immProfile.get('originCountry'));
        const bannerClassName = classNames({
            'broker-product-advanced-search__banner': !isOnlyOneProduct && !searchFailed,
            'broker-product-advanced-search__one-product-banner': isOnlyOneProduct && !searchFailed,
            'broker-product-advanced-search__service-failed-banner': searchFailed
        });
        const resultListContent = this.getResultListContent();

        if (!isFetchingFilters && errorfilters && !searchFailed) {
            return (
                <div className="row broker-product-advanced-search__empty-state">
                    {AdvancedSearchEmptyStateRetry(onHandleRetryFiltersFailed)}
                </div>
            );
        }
        let commercialAds;
        if (!hideCommercialAds) {
            commercialAds = brokerIAEnabled ? (
                <div className="col-lg-4">
                    <BrokerIABanner
                        titleKey="brokerIA-broker_ai_pre_contract_title_risk_slide"
                        subtitleKey="brokerIA-broker_ai_pre_contract_detail_risk_slide"
                        type="search-results"
                        extraClass={bannerClassName}
                     />
                </div>
            ) : (
                <div className="col-lg-4 broker-product-advanced-search__commercial">
                    <CommercialAds path="broker/explore" type="banner-d" extraClass={bannerClassName}/>
                </div>
            );
        }
        const resultClasses = classNames({
            'col-lg-8 broker-product-advanced-search__result': !hideCommercialAds
        });

        if (fetched) {
            if (!searchEmpty) {
                return (
                    <div className="col-lg-12">
                        <div className={resultClasses}>
                            {resultListContent}
                            {this.buildLegalText()}
                            <LoadingWithOpacity contextClass="broker-product-advanced-search__result" visible={isFetching} top={400}/>
                        </div>
                        {commercialAds}
                    </div>
                );
            } else {
                return this.getEmptyState();
            }
        } else {
            return(
                <LoadingWithOpacity contextClass="broker-product-advanced-search__content" visible={isFetching} top={20}/>
            );
        }
    }

    render() {
        const content = this.buildContent();
        const watchlistModal = this.buildWatchlistModal();
        const fiscalDisclaimer = this.buildFiscalWarning();

        return (
            <div className="broker-product-advanced-search__content">
                <div className="grid-view__body">
                    <div className="row">
                        {content}
                        {fiscalDisclaimer}
                        {watchlistModal}
                    </div>
                </div>
            </div>
        )
    }
}

BrokerProductAdvancedSearch.propTypes = {
    productDetailsToList: PropTypes.func.isRequired,
    addToExistingList: PropTypes.func.isRequired,
    createNewList: PropTypes.func.isRequired,
    watchlistModalToggle: PropTypes.func.isRequired,
    deleteProductFromList: PropTypes.func.isRequired,
    resetWatchlistDetails: PropTypes.func.isRequired,
    getUserWatchlist: PropTypes.func.isRequired,
    submitNewListName: PropTypes.func.isRequired,
    listSelected: PropTypes.func.isRequired,
    saveListName: PropTypes.func.isRequired,
    immBrokerWatchlist: PropTypes.object.isRequired,
    immBrokerAttentionPlanStartingModal: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immBrokerProductFiltersSearch: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    advancedSearchProducts: PropTypes.func.isRequired,
    hasNoStockContracts: PropTypes.bool,
    searchSpecificProduct: PropTypes.func.isRequired,
    searchSpecificProductTracking: PropTypes.func,
    searchWithPage: PropTypes.func.isRequired,
    productType: PropTypes.string,
    retryCombosFilters: PropTypes.func,
    updateFiltersCombosConfiguration: PropTypes.func,
    retryAdvancedSearch: PropTypes.func,
    retryAdvancedSearchSpecificProduct: PropTypes.func,
    stopViewMoreRedirections: PropTypes.bool,
    showSelectButton: PropTypes.bool,
    handleClickSelectButton: PropTypes.func,
    hideCommercialAds: PropTypes.bool,
    watchlistTutorialHasBeenShown: PropTypes.bool
};

BrokerProductAdvancedSearch.defaultProps = {
    hasNoStockContracts: false,
    onHandleClickSelectButton: () => {}
}

module.exports = connect(
    state => ({
        immBrokerWatchlist: state.brokerWatchlist,
        immBrokerAttentionPlanStartingModal: state.brokerAttentionPlanStartingModal,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immProfile: state.profile,
    }),{
        addToExistingList: BrokerWatchlistActions.addToExistingList,
        createNewList: BrokerWatchlistActions.createNewList,
        productDetailsToList: BrokerWatchlistActions.productDetailsToList,
        deleteProductFromList: BrokerWatchlistActions.deleteProductFromList,
        watchlistModalToggle: BrokerWatchlistActions.watchlistModalToggle,
        resetWatchlistDetails: BrokerWatchlistActions.resetWatchlistDetails,
        listSelected: BrokerWatchlistActions.listSelected,
        saveListName: BrokerWatchlistActions.saveListName,
        getUserWatchlist: BrokerWatchlistActions.getUserWatchlist,
        submitNewListName: BrokerWatchlistActions.newListName,
    }
)(BrokerProductAdvancedSearch);
